import React from 'react';
import './contact.scss';
import Mail from './Mail';
import { Trans } from "@lingui/react";


const Contact = () => {
  return (
    <div className='component-contact'>
      <h2><Trans id="contacts" /></h2>
      <p style={{textAlign:'center'}}><strong><Trans id="aboutAdinistration"/></strong></p>
      <div className='contact-us-block'>
        <section className='aside-box'>
          <img src={"/assets/pic2.png"} alt="Description of image" />
        </section>
        <section className="contact">
          <Mail />
        </section>
      </div>
    </div>

  );
};

export default Contact;
